import { isFalsyOrEmpty } from 'src/app/shared/utils/string.utils';
import { Application } from '../models/application';

export class ApplicationHelper {
    static hasLinks(application: Application): boolean {
        return !isFalsyOrEmpty(application?.docs) || !isFalsyOrEmpty(application?.community);
    }

    static readonly defaultThemeColor = '#00aeff';
}
